jQuery(document).ready(function($){

	const $loader = $('.wrap--signatures-loader');

	function signaturesInitPackery( listingQty, isPageLoad = true ) {

		if ( 
				// If automatic listing, OR manual but with NO remnants listing
				'single' === listingQty || 
				// If manual with remnants listing, NOT on page load - this is very similar 
				// to the previous scenarion, we need to handle one packery only.
				(
					'double' === listingQty &&
					false === isPageLoad
				)				
			) {

			const $packeryContainer = ( 'single' === listingQty )
										? $('.mac-module--signatures .wrap--items')
										: $('.remnants__main .wrap--items'),
				  $sPackery 		= $packeryContainer.packery({
					// options
					itemSelector: '.signature',
					columnWidth: '.grid-sizer',
					//percentPosition: true,					  
					gutter: '.gutter-sizer',
					//resize: true,
				  });

			$packeryContainer.on( 'layoutComplete', function() {

				if ( $loader.is(':visible') ) {

					$loader.removeClass('loading');
					$('.wrap--full').fadeTo('fast', 1);

				}

			})

			// This is required - otherwise the 'layoutComplete' event is not
			// dispatched!!!
			$packeryContainer.packery('layout');					  

		// If manual with remnants listing, ON page load - this is the only scenario
		// where we have to deal with multiple packery inits.
		} else if (
			'double' === listingQty &&
			true === isPageLoad
		) {

			// If manual curation is the selected option, and the user also enables
			// the "remnants listing", it means two Packery sections. Let's use a
			// jQuery each.
			let i 					= 0,
				$sPackery 			= [],
				layoutCompleteNo 	= 0;
			$('.mac-module--signatures .wrap--items').each( function(i, container) {

				$sPackery[i] = $(container).packery({
					// options
					itemSelector: '.signature',
					columnWidth: '.grid-sizer',
					//percentPosition: true,					  
					gutter: '.gutter-sizer',
					//resize: true,
				});

				$sPackery[i].on( 'layoutComplete', function() {

					layoutCompleteNo++;				
					//console.log(layoutCompleteNo);

					// Fade out the loader animation.
					if ( $loader.is(':visible') ) {

						$loader.removeClass('loading');
						$('.wrap--full').fadeTo('fast', 1);

					}					

				})						

				i++;

			})

			$.each($sPackery, function(i, packeryInstance) {

				// This is required - otherwise the 'layoutComplete' event is not
				// dispatched!!!
				packeryInstance.packery('layout');

			});					

		}

	}

	if ( $('.mac-module--signatures').length ) {

		const $mod 				= $('.mac-module--signatures'),
			  hasDoubleListings = ( 
									'manual' === $mod.attr('data-listing') 	&&
									$mod.find('.remnants__main').length 	&&
									'' !== $mod.find('.remnants__main').attr('data-curated')
								  );
		let listingQty = hasDoubleListings
							? 'double'
							: 'single';

		// The loader animation should load upon page load as well - not just upon 
		// paginating!!
		MacFunctions.signaturesLoader( $loader );	

		signaturesInitPackery( listingQty, true );

		if ( $('.signatures__pagination').length ) {

			/*$('.signatures__pagination a').each(function() {
				console.log(this.href);
			})*/

		    $(document).on('click', '.signatures__pagination a', function (e) {

		        e.preventDefault();       

		        //let pageUrl = $(this).attr('href');
		        //
		        // FYKI - the above version won't work 
		        // 		  - if on localhost
		        // 		  - and/or the pagination link doesn't include the port and the domain,
		        // 		    due to a specific 'format' value in the `paginate_links()` PHP
		        // 		    function configuration
		        // 		  
		        // 		  FIX: you should use `this.href` instead.
		        // 		  
		        //  More on this @here:
		        //  
		        //  https://stackoverflow.com/questions/74767997/failed-to-construct-url-invalid-url#answer-74768629
		        //  
		        let pageUrl = this.href,
		        	page 	= new URLSearchParams(new URL(pageUrl).search).get('paged');

		        const $scontainer = $(this).closest('.wrap--mac-signatures');
		        //console.log($scontainer);

		        // FIX - without the below update, the first page's link loses its href value 
		        // 		 with the first AJAX update, breaking the pagination if the user tries 
		        // 		 to get back to page 1.
		        if ( null === page ) 
		        	page = '01';

		        //console.log(page);	

		        // If the user selected manual curation, and to desplay the second listing 
		        // of remnants there, we should exclude the manually curated signatures from
		        // this second listing.

		        let dataCuratedJSON = '',
		        	dataCuratedArr 	= [];

		        if ( $(this).closest('.remnants__main').length ) {

					// Get the JSON data from the attribute
					dataCuratedJSON = $('.remnants__main').attr('data-curated');
					
					// Parse the JSON string into a JavaScript array
					// 
					// FYKI - THIS IS ONLY NECESSARY IF THE DATA REQUIRES ANY KIND OF PROCESSING
					// 		  BEFORE SENDING IT TO THE PHP AJAX HANDLER!!!
					// 		  Otherwise, it's already JSONified before being passed as an HTML 
					// 		  data attribute value, so it's ready to be passed along in the jQuery 
					// 		  AJAX function. 
					dataCuratedArr = JSON.parse(dataCuratedJSON);

				}

				//console.log(dataCurated);		                

		        $.ajax({
		            url: mod.ajaxurl,
		            type: 'POST',
		            data: {
		                action: 'load_signatures_pagination',
		                page: page,
		                dataCurated: dataCuratedJSON, 	// this would be 
		                								// `JSON.stringify(dataCuratedArr)`
		                								// if any JS processing were necessary
		                								// before sending the data to the PHP
		                								// AJAX handler - see FYKI comment
		                								// above where the `dataCuratedArr`
		                								// value udpate is.
		            },
		            beforeSend: function (jqXHR, settings) {

						//console.log( jqXHR );
						//6console.log( settings );

						$loader.addClass('loading');

						const $scrollTarget = hasDoubleListings
							  				? $('.remnants__main')[0]
							  				: $scontainer[0];	

						gsap.to(window, {
							duration: 0.5,
							scrollTo: { y: $scrollTarget, offsetY: 140 },
							ease: "Power1.easeInOut"
						});

		                $('.wrap--full').fadeTo('fast', 0, function() {


		                });
		            
		            },
		            success: function (response, textstatus, jqXHRObject) {

						//console.log(response);
						//console.log('textstatus:' + textstatus);
						//console.log(jqXHRObject.responseJSON.message);	

						const $mod 			= $('.mac-module--signatures'),
							  $sigWrap 		= hasDoubleListings
								  				? $mod.find('.remnants__main')
								  				: $mod.find('.signatures__main'),
							  $packeryWrap 	= $sigWrap.find('.wrap--full'),
							  $wrapItems 	= $sigWrap.find('.wrap--items');

						$packeryWrap.html(response);
	                	signaturesInitPackery( listingQty, false );
		                $packeryWrap.fadeTo('fast', 1, function() {});			            
		            
		            },
			      	error: function($xhr){

			      		//console.log('AJAX request failed :(');
			      		//console.log($xhr);	
		              
		              	// (...)                  

			      	}            

		        });

		    });

		}

	}

})

/**
 * $(window).on('load', function() {}) DOESN'T WORK IN INCOGNITO!!!
 *
 * EVERYTHING that should be processed upon the onload event MUST be handled here!!!
 */
jQuery(window).ready(function($) {



})

window.onload = function() {

	// jQuery hasClass alternative in vanilla JS
	//console.log( document.body.classList.contains('page-template') );
	//console.log( document.body.classList.contains('loaded') );	

	if ( !document.body.classList.contains('loaded') ) {

		//document.body.classList.remove("no-js");
		//document.body.classList.add('loaded-better');

	}

};